import { useEffect } from 'react';

import './App.css';

import Header from './Components/Header';
import VideoContainer from './Components/VideoContainer';
import FeedbackForm from './Components/FeedbackForm';
import ScreenshotContainer from './Components/ScreenshotContainer';
import PrivacyPolicy from './Components/PrivacyPolicy';

function App() {
  useEffect(() => {
    const { hash } = window.location;

    // if not a hash link, scroll to top
    if (hash === '') {
      window.scrollTo(0, 0);
    }
    // else scroll to id
    else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      }, 0);
    }
  }, []);
  
  return (
    <main className='App'>
      <Header />
      <VideoContainer />
      <article className='description'>
        <h1 className='text-center'>Remain Alive</h1>
        <p className='text-center'>Can you survive? An exciting new zombie survival game for Oculus App Labs is here!
          Use an arsenal of upgradable weapons to dispatch the dead and collect resources to upgrade
          your base. Watch the world change after every combat round as survivors join up.
        </p>
        <p className='text-center'>
          Play as a group of survivors who are battling for survival. 5 unique missions with different objectives offer
          a changing game environment. Search for weapons to make it easier for you to take on your enemies.
        </p>
        <p className='text-center'>
          Post content launch will be made available upon the success of the game. A survival wave or horde
          base mode will be a free update, along with more wepaons, buildable structures and defenses.
        </p>
        <p className='text-center'>
          <i>Oculus/Meta Quest 2 support only.</i>
        </p>
      </article>
      <ScreenshotContainer />
      <FeedbackForm />
      <PrivacyPolicy />
    </main>
  );
}

export default App;
